import { generatePath, Navigate } from "react-router";

import { PATHS } from "@/routes/paths";

import { useFetchContactInfo } from "../api";
import { ContactNewForm } from "./form";

type Props = {
	hotelID: string;
};

export const ContactNew = ({ hotelID }: Props) => {
	const { data } = useFetchContactInfo({ hotelID });

	if (!data) {
		return <Navigate to={generatePath(PATHS.HOTEL.CONTACT.TOP, { hotelID })} />;
	}

	return <ContactNewForm hotelID={hotelID} data={data} />;
};

ContactNew.displayName = "ContactNew";
